import React from 'react';
import PropTypes from 'prop-types';
import { getSpeakerImageUrl } from './utils';

const SpeakerAvatars = ({ presenters }) => {
  if (!presenters || presenters.length === 0) return null;

  return (
    <div className="session-item__avatars">
      {presenters.map((presenter, idx) => {
        const imgUrl = getSpeakerImageUrl(presenter);
        if (!imgUrl) return null;
        const key = presenter['@id'] || idx;
        return (
          /* eslint-disable-next-line no-restricted-syntax */
          <img key={key} src={imgUrl} alt={presenter.title} loading="lazy" />
        );
      })}
    </div>
  );
};

SpeakerAvatars.propTypes = {
  presenters: PropTypes.arrayOf(
    PropTypes.shape({
      '@id': PropTypes.string,
      title: PropTypes.string,
      image_scales: PropTypes.object,
    }),
  ),
};

export default SpeakerAvatars;
